'use client';

const SocialProofModal = ({ descriptionHtml }) => {
  return (
    <div className="px-6 py-10 sm:px-8 sm:py-12 lg:px-10 lg:py-8 font-worksans text-primary text-center">
      {descriptionHtml && (
        <div
          className="rte-content rte-content--light text-base leading-relaxed [&_:is(h1,h2,h3,h4)]:[font-family:var(--font-cormorant)] [&_:is(h1,h2,h3,h4)]:text-2xl [&_:is(h1,h2,h3,h4)]:font-normal [&_:is(h1,h2,h3,h4)]:mb-4 [&_p:last-child]:mb-0"
          dangerouslySetInnerHTML={{ __html: descriptionHtml }}
        />
      )}
    </div>
  );
};

export default SocialProofModal;
